// Landing page constants
export const SEEDED_WAITLIST_COUNT = 1284;

// API endpoints - uses environment variable
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
